import { nanoid } from 'nanoid'
const OSS = require('ali-oss')
let OSSConfig = ''
function getConfig(data) {
  OSSConfig = data;
}
// const OSSConfig = {

//   uploadHost: 'http://dlhuimin.cn-beijing.aliyuncs.com/', //OSS上传地址

//   ossParams: {

//     region: 'cn-beijing',

//     success_action_status: '200', // 默认200

//     endpoint: "https://oss-cn-beijing.aliyuncs.com",

//     accessKeyId: 'STS.NU4wgHMvuwo8Pb6Aa2cNTHUmo',

//     accessKeySecret: 'HLbBCG9B3AyYMQzyEX1Ao3A22kWxHZAGPhaaTapmEpH9',

//     bucket: 'dlhuimin',

//   },

// }

function random_string(len) {

  len = len || 32

  var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'

  var maxPos = chars.length

  var pwd = ''

  for (let i = 0; i < len; i++) {

    pwd += chars.charAt(Math.floor(Math.random() * maxPos))

  }

  return pwd

}

function uploadOSS(file) {
  return new Promise(async (resolve, reject) => {
    const fileName =  OSSConfig.fileName + '/' + nanoid() + file.name.substr(file.name.lastIndexOf("."))

    let client = new OSS({

      region: OSSConfig.regionId,

      endpoint: OSSConfig.endpoint,

      accessKeyId: OSSConfig.role.credentials.accessKeyId,

      accessKeySecret: OSSConfig.role.credentials.accessKeySecret,

      bucket: OSSConfig.bucket,

      stsToken: OSSConfig.role.credentials.securityToken

    })
    const res = await client.multipartUpload(fileName, file)
    res.fileNames = file.name;
    resolve(res)

    // 或者返回如下：

    resolve({

        fileUrl: `${OSSConfig.uploadHost}/${fileName}`,

        fileName: file.name

    })

  })

}

export { uploadOSS, getConfig }


// WEBPACK FOOTER //
// ./src/utils/oss.js